"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FooterContactInfo_1 = __importDefault(require("./FooterContactInfo"));
exports.default = FooterContactInfo_1.default;
